import React, {FC, useEffect} from 'react'
import {useFormContext, Controller} from 'react-hook-form'
import {FilterRegex} from '../../../util/functions'

type InputProps = {
  type?: string
  name: string
  textPlaceholder?: string
  maxLength?: number
  minLength?: number
  disabled?: boolean | undefined
  min?: number
  max?: number
}

const InputNumber2: FC<InputProps> = ({
  type = 'number',
  name,
  textPlaceholder,
  maxLength = 9999,
  minLength = 0,
  disabled = false,
  min,
  max,
  ...props
}) => {
  const {
    control,
    formState: {errors},
    setValue,
    watch,
  } = useFormContext()
  const value = watch(name) ?? ''

  useEffect(() => {
    if (value === undefined) {
      setValue(name, '')
    }
  }, [value, setValue, name])

  return (
    <div className='sdx_form_input'>
      <Controller
        name={name}
        control={control}
        defaultValue={value}
        render={({field}) => (
          <input
            type='number'
            className='form-control sdx-centra-input-form'
            {...field}
            placeholder={textPlaceholder}
            maxLength={maxLength}
            minLength={minLength}
            disabled={disabled}
            min={min}
            max={max}
            // onChange={(e) => handleChange(e, field)}
          />
        )}
      />
      {errors[name] && <p>{errors[name]?.message?.toString()}</p>}
    </div>
  )
}

export default InputNumber2
